<template>
    <div>
        <components :is="integration.id" :model="integration" :active="isActive" ></components>
    </div>
</template>
<script>
export default {
    components: {
        ProtokolEnvoy: () => import("@/views/integrations/protokol/Envoy"),
        ProtokolWebforms: () => import("@/views/integrations/protokol/Webforms"),
        ProtokolStorefront: () => import("@/views/integrations/protokol/Storefront"),
        ProtokolMedia: () => import("@/views/integrations/protokol/Media"),
        ProtokolInvoicing: () => import("@/views/integrations/protokol/invoicing/Index"),
        'protokol-vpfr': () => import("@/views/integrations/protokol/vpfr/Index"),
        'protokol-ocr': () => import("@/views/integrations/protokol/ocr/Index"),
        'protokol-clerk': () => import("@/views/integrations/protokol/clerk/Index"),
        'protokol-payments': () => import("@/views/integrations/protokol/payments/Index"),
        'protokol-deliveries': () => import("@/views/integrations/protokol/deliveries/Index"),
        'protokol-minimax': () => import("@/views/integrations/protokol/minimax/Index"),
        'protokol-mail': () => import("@/views/integrations/protokol/mail/Index"),
        'protokol-ecommerce': () => import("@/views/integrations/protokol/ecommerce/Index"),
        'protokol-inbox': () => import("@/views/integrations/protokol/inbox/Index"),
        'protokol-support': () => import("@/views/integrations/protokol/support/Index"),
    },

    props: {
        model: {
            Type: Object,
            default: function() {
                return null
            }
        }
    },

    computed: {
        integration() {
            if (this.model !== null) return this.model

            let providers = Object.keys(integrations)

            console.log("providers", providers)

            let int = null
            providers.forEach(p => {
                int = integrations[p].find(i => {
                    return i.id == this.$route.params.id
                })
            })

            return int
        },

        isActive() {
            return this.$store.getters.isIntegrationActive(this.integration.id)
        }
    }

}
</script>